import { render, staticRenderFns } from "./DuplicateList.vue?vue&type=template&id=16e5941b&"
import script from "./DuplicateList.vue?vue&type=script&lang=js&"
export * from "./DuplicateList.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports